// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"_l-z","summaryPar":"am-z","ratingCategories":"bm-z","reviewerInfo":"cm-z","reviewTypes":"dm-z","expanded":"em-z"};